import { registerKnownModules } from "./app/knownModules";
import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { require, define, setBaseUrlAndVersion } from "./app/core/require.js";
import { registerCustomPanelbar } from "./app/core/components/isPanelbarDetails.js";
import 'devextreme/dist/css/dx.light.css';
import devexpressConfig from 'devextreme/core/config';

(window as any).define = define;
(window as any).require = require;
(window as any).React = React;
(window as any).ReactDOM = ReactDOM;
(window as any).axios = axios;
(window as any).setBaseUrlAndVersion = setBaseUrlAndVersion;
(window as any).registerCustomPanelbar = registerCustomPanelbar;

registerKnownModules();
devexpressConfig({ licenseKey: "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjdmNjJiYWQ1LThkZTctNGU2OS05MGZkLWZmZGI5YTc4NGQ5NCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.OcYdjkz0Avzoos0zb+66l97T0MajpaQJbDvy/6XXlxyeVQ1zVLrgeb3MK8jyFXkEZ24ivhvc2o94uesfJFws0WNuupWFKWRTSJXtQQWQpF535gUIhyfXlaxaBRIJPtDMCxIN1A==" });
export { require };